import { adminRequest } from './adminApi'

export interface AdminLogFilters {
  level?: string
  component?: string
  request_id?: string
  q?: string
  limit?: number
  offset?: number
}

export interface AdminLogEntry {
  time: string
  level: string
  message: string
  component?: string
  request_id?: string
  attrs?: Record<string, unknown>
}

export interface AdminLogsResponse {
  entries: AdminLogEntry[]
  limit: number
  offset: number
  total: number
}

export interface AdminModelPerfRow {
  model_alias: string
  count: number
  avg_latency_ms: number
  p95_latency_ms: number
  error_rate: number
  cost_usd: number
}

export interface AdminServicePerfRow {
  service_kind: string
  count: number
  avg_latency_ms: number
  p95_latency_ms: number
  error_rate: number
  cost_usd: number
}

export interface AdminSlowRequestRow {
  source: string
  id?: string
  model_alias?: string
  service_kind?: string
  latency_ms: number
  success: boolean
  cost_usd: number
}

export interface AdminPerfSummary {
  models: AdminModelPerfRow[]
  services: AdminServicePerfRow[]
  slow_requests: AdminSlowRequestRow[]
}

function buildQuery(filters: AdminLogFilters = {}): string {
  const qs = new URLSearchParams()
  for (const [key, value] of Object.entries(filters)) {
    if (value === undefined || value === null || value === '' || value === 'all') continue
    qs.set(key, String(value))
  }
  const query = qs.toString()
  return query ? `?${query}` : ''
}

export const adminObservabilityApi = {
  logs: (filters?: AdminLogFilters): Promise<AdminLogsResponse> =>
    adminRequest<AdminLogsResponse>(`/v1/admin/observability/logs${buildQuery(filters)}`),
  perfSummary: (): Promise<AdminPerfSummary> =>
    adminRequest<AdminPerfSummary>('/v1/admin/observability/perf/summary'),
}

